import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Autocomplete } from 'module-tsl-ui-elements';
import AutocompleteWithDocgen from 'module-tsl-ui-elements/with-docs/autocomplete/Autocomplete';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<Autocomplete name="autocomplete"
                       minSearchLength={3}
                       onTypedTextChanged={input => {}}
                       onSuggestionSelected={input => {}}
                       onChange={()=>{}}
                       searchList={[{ label: 'Autopilot'},{ label: 'Autoloading'}]} />`}
  scope={{ Autocomplete }}
/>
<PropsTable data={AutocompleteWithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  